<template>
  <div class="layout-week">
    <div class="titles d-flex">
      <div class="title flex-fill" v-for="day in days">{{day.label}}</div>
    </div>
    <div class="logs d-flex">
      <div class="column flex-fill" v-for="day in days">
        <div
          v-for="log in logsByDate(day.date)"
          class="log"
          :class="selectedLog && selectedLog.id === log.id ? 'selected' : ''"
          :style="logStyle(log, day.date)"
          @click="selectLog(log)"
        >
          <img :src="log.user.iconUrl" />
          <span v-if="log.account">
            {{log.account.name}}
            <br />
          </span>
          <span>{{log.project.title}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import toDate from "date-fns/toDate";
import subSeconds from "date-fns/subSeconds";
import subWeeks from "date-fns/subWeeks";
import addWeeks from "date-fns/addWeeks";
import addDays from "date-fns/addDays";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import formatDate from "date-fns/format";
import isWithinInterval from "date-fns/isWithinInterval";

const sameDate = function(date1, date2) {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

export default {
  props: ["logs", "selected-log", "slug"],
  methods: {
    selectLog(log) {
      this.$emit("select-log", {
        selectedLog: log
      });
    }
  },
  computed: {
    currentDate() {
      return parse(this.slug, "YYYY-MM-DD", new Date());
    },
    days() {
      let days = [];
      let cursor = startOfWeek(this.currentDate, {
        weekStartsOn: 1
      });
      for (let i = 0; i < 7; i++) {
        let date = new Date(cursor.getTime());
        days.push({
          date: date,
          label: formatDate(date, "ddd Do MMM")
        });
        cursor = addDays(cursor, 1);
      }

      return days;
    },
    logsByDate() {
       return function(day) {
         const daySlug = formatDate(day, 'YYYY-MM-DD');
         return this.logs.filter((item) => {
           return isWithinInterval(day, {
             start: parse(item.startTime.requested, 'YYYY-MM-DD', new Date),
             end: subSeconds(toDate(item.endTime.requested), 1),
           });
         });
       }
     },
    logStyle() {
      return function(log, currentDate) {
        const rowHeight = 30;
        const start = new Date(log.startTime.requested);
        const end = new Date(log.endTime.requested);

        const startHour = sameDate(start, currentDate)
          ? start.getHours() + start.getMinutes() / 60
          : 0;
        const endHour = sameDate(end, currentDate)
          ? end.getHours() + end.getMinutes() / 60
          : 24;
        let style = {
          marginTop: startHour * rowHeight + "px",
          height: (endHour - startHour) * rowHeight + "px",
          backgroundColor: log.project.color
        };

        return style;
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// assets/js/components/work-logs/Week.vue